var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPattern2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 51,
    viewBox: "0 0 106 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_50_186",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 106,
    height: 51
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 105.613,
    height: 51,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_50_186)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1.82812,
    y: 16.7505,
    width: 109.157,
    height: 34.2548,
    fill: "#FFDADF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.44432 5.98207L-1.37138 5.6319C0.713802 5.29288 4.8597 4.59254 8.99284 3.86937C13.1255 3.13451 17.2448 2.36513 21.402 2.17923C25.5591 1.99334 29.7541 2.39092 33.9739 3.07999C38.1936 3.76905 42.4147 4.75064 46.5996 5.18379C50.785 5.62861 54.9335 5.51332 59.1012 5.56103C63.2688 5.60873 67.4554 5.81944 71.6073 4.99009C75.7591 4.16075 79.8528 2.29239 83.976 1.34729C88.0992 0.402194 92.252 0.380343 96.4332 0.731731C100.615 1.0948 104.826 1.84279 106.943 2.21626L109.048 2.59025L109.826 19.9936L107.742 20.0868C105.646 20.1805 101.477 20.3669 97.3195 20.5528C93.1623 20.7387 89.0169 20.9241 84.8597 21.11C80.7026 21.2959 76.5337 21.4823 72.3531 21.6692C68.1725 21.8562 64.0036 22.0426 59.8465 22.2285C55.6893 22.4144 51.5438 22.5998 47.3867 22.7857C43.2295 22.9716 39.0606 23.158 34.8801 23.3449C30.6995 23.5319 26.5306 23.7183 22.3734 23.9042C18.2163 24.0901 14.0708 24.2754 9.91365 24.4613C5.75648 24.6472 1.5876 24.8337 -0.508544 24.9274L-2.59298 25.0206L-3.44432 5.98207Z",
    fill: "#FFDADF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern2);
export default __webpack_public_path__ + "static/media/pattern2.07dd7689f94381a69601faa2a9596152.svg";
export { ForwardRef as ReactComponent };